export enum UCConsentServiceNames {
    Relewise = 'Relewise'
}

export enum UCServiceControllerIdCookieNames {
    Relewise = 'uc-controller-id-relewise'
}

// The controller id was previously stored in a relewise-specific cookie. We still read and
// clean it up to avoid losing tracking data, but only the new cookie is written.
// TODO: Remove all legacy cookie handling once the new cookie has been live for a while.
export const LEGACY_CONTROLLER_ID_COOKIE_NAME = 'relewise-temporary-user-id';

export const UC_SERVICES = [
    {
        serviceName: UCConsentServiceNames.Relewise,
        cookieName: UCServiceControllerIdCookieNames.Relewise
    }
];
